import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bonusomat-board__notification"
}
const _hoisted_2 = { class: "bonusomat-slots__action-bar bonusomat-slots__action-bar--inactive bonusomat-slots__action-bar--separated" }
const _hoisted_3 = { class: "bonusomat-slots__group" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "bonusomat-placeholder"
}
const _hoisted_6 = { class: "bonusomat-board__board" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "bonusomat-board__modal__games"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "bonusomat-board__modal__game__img bonusomat-board__modal__game__img--no-icon"
}
const _hoisted_11 = { class: "bonusomat-modal__footer" }
const _hoisted_12 = { class: "bonusomat-modal__footer__progress-wrapper" }
const _hoisted_13 = { class: "bonusomat-modal__footer__texts" }
const _hoisted_14 = { class: "bonusomat-modal__footer__state" }

import { computed, ref, watch } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import TransitionExpand from "@sazka/design-system/src/transitions/transition-expand.vue";
import TypographyHeadline from "@sazka/design-system/src/typography/typography-headline.vue";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import BonusomatBoardCompleted from "./bonusomat-board-completed.vue";
import BoardFilter from "./bonusomat-board-filter.vue";
import BoardRules from "./bonusomat-board-rules.vue";
import BoardTask from "./bonusomat-board-task.vue";
import useBonusomatData from "../../composables/use-bonusomat-data";
import { BonusomatBoardTask } from "../../models/bonusomat-board";
import { BoardFilterOption, BonusomatFilterValues } from "../../models/bonusomat-board-filter";
import { BonusomatQuestGame } from "../../models/bonusomat-quest-detail";
import BonusomatProgress from "../shared/bonusomat-progress.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-board',
  setup(__props) {

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { isPlayerDataLoaded, remainingSpinsCount } = bonusomatPlayerStatus;

const {
    isBoardDataLoaded,
    isDefaultDrawDataLoaded,
    hasActiveQuest,
    boardData,
    gamesData,
    deactivateQuest,
    openGame,
    loadGamesData,
} = useBonusomatData();

const showActiveQuestBanner = computed(() => {
    return remainingSpinsCount.value > 0 && hasActiveQuest.value;
});

const isBoardCompleted = computed(() => boardData.value?.completed);

const filterValue = ref<BonusomatFilterValues>(BonusomatFilterValues.All);
const filterOptions: BoardFilterOption[] = [
    {
        value: BonusomatFilterValues.All,
        text: "Vše",
    },
    {
        value: BonusomatFilterValues.Uncompleted,
        text: "Nesplněné",
    },
    {
        value: BonusomatFilterValues.Completed,
        text: "Splněné",
    },
    {
        value: BonusomatFilterValues.Repeating,
        text: "Opakující se",
    },
];

const tasksFiltered = computed<BonusomatBoardTask[]>(() => {
    return boardData.value?.tasks.filter(({ completed, repeatable }) => {
        if (filterValue.value === BonusomatFilterValues.Completed) return completed;
        if (filterValue.value === BonusomatFilterValues.Repeating) return repeatable;
        if (filterValue.value === BonusomatFilterValues.Uncompleted) return !completed;
        if (filterValue.value === BonusomatFilterValues.All) return true;
    });
});

// used to reload progress components on certain actions (fixes issue on IOS where progress animation doesn't work reliably by itself)
const progressLoadCounter = ref(0);

const isModalOpen = ref(false);
const activeTask = ref<BonusomatBoardTask>(null);
const activeTaskGames = computed(() => gamesData.value.filter((game) => activeTask.value?.games?.includes(game.id)));

const modalFooterText = computed(() => {
    const taskProgress = activeTask.value?.progress;
    return taskProgress === 100
        ? "Dokončeno"
        : `Zbývá ${100 - (taskProgress > 99 ? Math.floor(taskProgress) : Math.round(taskProgress))} %`;
});

const openModal = (task: BonusomatBoardTask) => {
    isModalOpen.value = true;

    if (!gamesData.value?.length) {
        loadGamesData();
    }

    activeTask.value = task;
};

watch(filterValue, async () => {
    setTimeout(() => {
        progressLoadCounter.value++;
    }, 500);
});

const closedModal = () => {
    setTimeout(() => {
        progressLoadCounter.value++;
    }, 200);

    activeTask.value = null;
};

const openGameClick = async (game: BonusomatQuestGame) => {
    openGame(game.id, game.type);

    activeTask.value = null;
    isModalOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["bonusomat-board", {
            'bonusomat-board--disabled': _unref(hasActiveQuest),
        }])
  }, [
    _createVNode(TransitionExpand, null, {
      default: _withCtx(() => [
        (showActiveQuestBanner.value && !isBoardCompleted.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(WebpImage, {
                  src: "/frontend/web/img/casino/bonusomat/automat/automat.png?v=1",
                  alt: "Bonusomat",
                  class: "bonusomat-slots__bar-image"
                }),
                _createVNode(DsIcon, {
                  name: "b-mat",
                  class: "bonusomat-slots__bar-icon"
                }),
                _createElementVNode("div", _hoisted_3, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bonusomat-slots__text" }, [
                    _createTextVNode(" Během hraní Questu "),
                    _createElementVNode("span", { class: "bonusomat-slots__text--thin" }, "se neplní úkoly Bonusomatu")
                  ], -1)),
                  _createVNode(DsButton, {
                    size: "sm",
                    type: "error",
                    "icon-right": "cross",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(deactivateQuest)('main')))
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" Ukončit Quest ")
                    ])),
                    _: 1,
                    __: [3]
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(isBoardDataLoaded) && _unref(isPlayerDataLoaded) && _unref(isDefaultDrawDataLoaded))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (isBoardCompleted.value)
            ? (_openBlock(), _createBlock(BonusomatBoardCompleted, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(TypographyHeadline, {
                  type: "section",
                  theme: "dark",
                  class: "bonusomat-board__filter"
                }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createTextVNode(" Úkoly ")),
                    _createVNode(BoardFilter, {
                      modelValue: filterValue.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterValue).value = $event)),
                      options: filterOptions
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1,
                  __: [5]
                }),
                (_unref(boardData)?.tasks.length)
                  ? (_openBlock(), _createBlock(_TransitionGroup, {
                      key: 0,
                      name: "board-task",
                      tag: "div",
                      class: "bonusomat-board__board"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasksFiltered.value, (task) => {
                          return (_openBlock(), _createBlock(BoardTask, {
                            "progress-load-counter": task.position + '-' + progressLoadCounter.value.toString(),
                            key: task.position,
                            name: task.name,
                            icon: task.icon,
                            repeatable: task.repeatable,
                            completed: task.completed,
                            progress: task.progress,
                            onClick: ($event: any) => (openModal(task)),
                            "is-active": task.position === activeTask.value?.position
                          }, null, 8, ["progress-load-counter", "name", "icon", "repeatable", "completed", "progress", "onClick", "is-active"]))
                        }), 128)),
                        (tasksFiltered.value.length === 0 && filterValue.value === _unref(BonusomatFilterValues).Completed)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Zatím zde nemáte žádné splněné úkoly, tak neváhejte a pusťte se do akce. "))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[6] || (_cache[6] = [
                      _createElementVNode("div", { class: "bonusomat-placeholder__text" }, "Při načítání úkolů nastala chyba", -1),
                      _createElementVNode("div", { class: "bonusomat-placeholder__subtext" }, "Zkuste to prosím později", -1)
                    ]))),
                _createVNode(BoardRules, {
                  "min-bet-amount": _unref(boardData)?.minimumBetAmount,
                  "rules-lik": _unref(boardData)?.rules
                }, null, 8, ["min-bet-amount", "rules-lik"])
              ], 64))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(TypographyHeadline, {
            type: "section",
            theme: "dark",
            class: "bonusomat-board__filter"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("Úkoly")
            ])),
            _: 1,
            __: [7]
          }),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(45, (index) => {
              return _createVNode(BoardTask, {
                key: index,
                class: "bonusomat-placeholder__skeleton",
                style: _normalizeStyle({
                        animationDelay: `${index * 0.01}s`,
                    })
              }, null, 8, ["style"])
            }), 64))
          ])
        ], 64)),
    _createVNode(DsModalDialog, {
      modelValue: isModalOpen.value,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((isModalOpen).value = $event)),
        closedModal
      ],
      "css-class": "bonusomat-board__modal bonusomat-modal",
      theme: "dark",
      "top-divider-visible": activeTaskGames.value?.length > 0,
      "bottom-divider-visible": false,
      "content-scrollable": ""
    }, {
      top: _withCtx(() => [
        _createVNode(DsTopSlotHeadlineSubheadline, {
          headline: activeTask.value?.name
        }, null, 8, ["headline"]),
        _createElementVNode("p", {
          class: "bonusomat-modal__description",
          innerHTML: activeTask.value?.description
        }, null, 8, _hoisted_7)
      ]),
      content: _withCtx(() => [
        (activeTaskGames.value?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeTaskGames.value, (game) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "bonusomat-board__modal__game",
                  key: game.id,
                  onClick: ($event: any) => (openGameClick(game))
                }, [
                  (game.icon)
                    ? (_openBlock(), _createBlock(WebpImage, {
                        key: 0,
                        src: game.icon,
                        alt: `Ikona hry ${game.name}`,
                        "css-class": "bonusomat-board__modal__game__img"
                      }, null, 8, ["src", "alt"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10)),
                  _createTextVNode(" " + _toDisplayString(game.name), 1)
                ], 8, _hoisted_9))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      bottom: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(BonusomatProgress, {
              "client-id": "board-task-detail",
              progress: activeTask.value?.progress,
              "show-percentage-number": ""
            }, null, 8, ["progress"]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(modalFooterText.value), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "top-divider-visible"])
  ], 2))
}
}

})